import { list as getList } from "~/api/contractCustomerDatabase";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";
import { clearableStore } from "~/mixins/clearableStore";
import { MYSQL_VERSION_57, MYSQL_VERSION_80 } from "~/constants/databaseType";

export const state = {
  list: null,
  listByVersion: {
    [MYSQL_VERSION_57]: [],
    [MYSQL_VERSION_80]: []
  },
  isLoading: false,
  isInitialLoadPending: true
};

export const mutations = {
  ...clearableStore.mutations,
  [types.SET_IS_LOADING_CONTRACT_CUSTOMER_DATABASE](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_CUSTOMER_DATABASE](state, contractCustomer) {
    state.list = contractCustomer.data;
    
    state.listByVersion = {
      [MYSQL_VERSION_57]: contractCustomer.data.filter(customer => 
        !customer.typeId || 
        customer.typeId === Number(MYSQL_VERSION_57) || 
        customer.typeId === 0
      ),
      [MYSQL_VERSION_80]: contractCustomer.data.filter(customer => 
        !customer.typeId || 
        customer.typeId === Number(MYSQL_VERSION_80) || 
        customer.typeId === 0
      )
    };
    
    state.isInitialLoadPending = false;
  }
};

export const actions = {
  fetchCustomers({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_CUSTOMER_DATABASE, true);

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (!activeContractId) {
      return Promise.resolve();
    }

    return getList(activeContractId).then((response) => {
      let { data } = response;
      commit(types.SET_CONTRACT_CUSTOMER_DATABASE, data);
      commit(types.SET_IS_LOADING_CONTRACT_CUSTOMER_DATABASE, false);
    }).catch((error) => {
      commit(types.SET_IS_LOADING_CONTRACT_CUSTOMER_DATABASE, false);
      throw error;
    });
  }
};

export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  getCustomersByVersion: (state) => (versionId) => {
    const version = Number(versionId);
    return state.listByVersion[version] || [];
  },
  ...entityStoreStatus.getters
}
